<template>
  <div class="h-screen w-screen flex justify-center items-center text-3xl">
    LBD Storybook
  </div>
</template>
